'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var exporter = require('ipfs-unixfs-exporter');

var errCode = require('err-code');

var _require = require('../utils'),
    normalizeCidPath = _require.normalizeCidPath,
    mapFile = _require.mapFile,
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      preload = _ref.preload;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _get = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfsPath, options) {
      var pathComponents, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, file;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};

              if (!(options.preload !== false)) {
                _context.next = 10;
                break;
              }

              _context.prev = 2;
              pathComponents = normalizeCidPath(ipfsPath).split('/');
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](2);
              throw errCode(_context.t0, 'ERR_INVALID_PATH');

            case 9:
              preload(pathComponents[0]);

            case 10:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 12;
              _iterator = _asyncIterator(exporter.recursive(ipfsPath, ipld, options));

            case 14:
              _context.next = 16;
              return _awaitAsyncGenerator(_iterator.next());

            case 16:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 20;
              return _awaitAsyncGenerator(_step.value);

            case 20:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 28;
                break;
              }

              file = _value;
              _context.next = 25;
              return mapFile(file, _objectSpread(_objectSpread({}, options), {}, {
                includeContent: true
              }));

            case 25:
              _iteratorNormalCompletion = true;
              _context.next = 14;
              break;

            case 28:
              _context.next = 34;
              break;

            case 30:
              _context.prev = 30;
              _context.t1 = _context["catch"](12);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 34:
              _context.prev = 34;
              _context.prev = 35;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 39;
                break;
              }

              _context.next = 39;
              return _awaitAsyncGenerator(_iterator.return());

            case 39:
              _context.prev = 39;

              if (!_didIteratorError) {
                _context.next = 42;
                break;
              }

              throw _iteratorError;

            case 42:
              return _context.finish(39);

            case 43:
              return _context.finish(34);

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 6], [12, 30, 34, 44], [35,, 39, 43]]);
    }));

    function get(_x, _x2) {
      return _get.apply(this, arguments);
    }

    return get;
  }());
};